// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3p-l0","label":"LabeledBox_label__YvJMq"};